
import React from "react";
import {motion} from "framer-motion";
import './NavMenuToggle.css';

const Path = (props) => (
  <motion.path
    fill="transparent"
    strokeLinecap="round"
    strokeWidth="3"
    {...props}
  />
);

const transition = { duration: 0.33 };

export function NavMenuToggle({ toggle, isOpen, svg_color }) {
  let svg_stroke="hsl(0, 0%, 18%)"
  if (svg_color){
    svg_stroke = svg_color
  }
  return (
    <div className="nav-link-button" onClick={toggle}>
      <svg width="23" height="23" viewBox="0 0 23 23">
        <Path
          animate={isOpen ? "open" : "closed"}
          initial={false}
          variants={{
            closed: { d: "M 2 2.5 L 20 2.5", stroke: svg_stroke },
            open: { d: "M 3 16.5 L 17 2.5", stroke: svg_stroke },
          }}
          transition={transition}
        />
        <Path
          d="M 2 9.423 L 20 9.423"
          stroke={svg_stroke}
          animate={isOpen ? "open" : "closed"}
          initial={false}
          variants={{
            closed: { opacity: 1 },
            open: { opacity: 0 },
          }}
          transition={transition}
        />
        <Path
          animate={isOpen ? "open" : "closed"}
          initial={false}
          variants={{
            closed: { d: "M 2 16.346 L 20 16.346", stroke: svg_stroke },
            open: { d: "M 3 2.5 L 17 16.346", stroke: svg_stroke },
          }}
          transition={transition}
        />
      </svg>
    </div>
  );
}
